const eventList = document.querySelectorAll( '.event-list' );
let currentPage = 1;
let postsPerPage = 10;

const updateSeenCount = list => {
  const seenCount = list.querySelector( '.load-more-seen-count' );
  const eventList = list.querySelector( '.event-list__items' );
  const progressBar = list.querySelector( '.load-more__progress-bar' );
  const maxCount = list.querySelector( '.load-more-max-count' );
  const showMoreButton = list.querySelector( '.load-more button' );

  if (!seenCount || !eventList || !progressBar || !maxCount || !showMoreButton) {
    return;
  }

  progressBar.style.width = (eventList.querySelectorAll( '.event-list__item' ).length / parseInt( maxCount.innerText, 10 ) * 100) + '%';
  seenCount.innerText = eventList.querySelectorAll( '.event-list__item' ).length;

  if (seenCount && seenCount.innerText === maxCount.innerText) {
    showMoreButton.style.display = 'none';
  }
}

async function fetchMoreEvents() {
  try {
    const response = await fetch( ajaxurl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams( {
        action: 'load_more_events',
        paged: currentPage + 1,
        posts_per_page: postsPerPage
      } )
    } );

    if (!response.ok) {
      throw new Error( 'Network response was not ok' );
    }

    const data = await response.json();

    if (data.success) {
      eventList.forEach( list => {
        const eventItems = list.querySelector( '.event-list__items' );
        eventItems.insertAdjacentHTML( 'beforeend', data.data.html );
        const firstNewEvent = eventItems.children[(currentPage) * postsPerPage];
        if (firstNewEvent) {
          firstNewEvent.scrollIntoView( { behavior: 'smooth' } );
          firstNewEvent.focus();
        }
        currentPage++;
        updateSeenCount( list );
      } );
    } else {
      console.error( 'Error loading more events:', data.data.message );
    }
  } catch (error) {
    console.error( 'Fetch error:', error );
  }
}

if (eventList.length > 0) {
  [...eventList].forEach( list => {
    const showMoreButton = list.querySelector( '.load-more button' );

    updateSeenCount( list );

    if (!showMoreButton) {
      return;
    }

    showMoreButton.addEventListener( 'click', event => {
      event.preventDefault();
      fetchMoreEvents();
    } );
  } );
}
